var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isFloatingFooterhidden)?_c('div',{staticClass:"mobile-sticky-footer d-flex d-md-none",class:{ 'overlay-show-through': _vm.activeTourPoint === 'my-deal', 'overlay-enabled': _vm.isOverlayEnabled }},[_c('div',{staticClass:"d-flex w-100 footer-block"},[_vm._t("default")],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }